export const setMachineID = (payload) => {
    return{
        type:"SET_MACHINE_ID",
        data:payload
    }
}